import {useEffect} from 'react';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {getDurationForSelectedPages} from '@Libraries/poster-download-library';
import type {PosterLoadObject} from '@PosterWhiteboard/poster/poster.types';

export function useUpdateMp4DurationFromSelectedPages(
  posterObject: PosterLoadObject,
  selectedPages: string[],
  fileType: FileTypeOptions,
  setDuration: (duration: number) => void
): void {
  useEffect(() => {
    if (fileType !== FileTypeOptions.MP4) {
      return;
    }
    const duration = getDurationForSelectedPages(posterObject, selectedPages);
    setDuration(duration);
  }, [posterObject, selectedPages, fileType, setDuration]);
}
